import { render, staticRenderFns } from "./Draft Posts.vue?vue&type=template&id=6d4e4026&"
import script from "./Draft Posts.vue?vue&type=script&lang=js&"
export * from "./Draft Posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports